import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenNikePulloverHoodie = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[3].productName}
				color={product.allGear[3].color}
				size={product.allGear[3].sizes}
				price={product.allGear[3].price}
				img={product.allGear[3].img}
				miniImg1={product.allGear[3].miniImg1}
				miniImg2={product.allGear[3].miniImg2}
				miniImg3={product.allGear[3].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenNikePulloverHoodie;
